import React from "react"
import { HeroSecondaryType } from "../../types/heroTypes"
import { API } from "../../constants/constants"
import BaseHeadline from "../common/BaseHeadline"
import BaseSubheadline from "../common/BaseSubheadline"
import IconButton from "../common/IconButton"
import BaseRichtext from "../common/BaseRichtext"

export default function HeroSecondary(props: HeroSecondaryType) {
    return (
        <div className="max-w-content mx-auto lg:pt-16 pb-16 flex flex-col-reverse lg:flex-col">
            <img
                src={API + props.heroSecondaryImage?.url}
                alt={props.heroSecondaryImage?.description ?? props.heroSecondaryImage.name ?? "HeroImage"}
                className="w-full h-80 lg:h-auto lg:w-4/5 ml-auto rounded-default lg:aspect-[6/4] object-cover"
            />
            <div className=" lg:-mt-52 rounded-default py-8 px-12 w-full lg:w-1/2 relative z-10 bg-base-100">
                <BaseHeadline headlineType={1} label={props.heroSecondaryHeading} />
                {props.heroSecondarySubHeading && <BaseSubheadline label={props.heroSecondarySubHeading} />}
                <BaseRichtext content={props?.heroSecondaryText} classProps="pb-4" />
                {props.heroSecondaryIcon && (
                    <img
                        src={API + props.heroSecondaryIcon?.url}
                        alt={props.heroSecondaryIcon?.description ?? props.heroSecondaryIcon.name ?? "HeroSecondaryIcon"}
                        className="w-full max-h-16"
                    />
                )}
            </div>
        </div>
    )
}
